<template>
  <div class="animated fadeIn" id="listar-usuarios">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-user"></i> Listagem de Usuários
      </div>
      <div class="card-body">
        <datatable-panel :per-page="30"
          :url="`${$root.url}/v-usuario?token=${$root.usuario('access_token')}`"
          :fields="fields"
          :sortField="fields[1]"
          ref="datatable"
          :searchBar="searchBar">
        </datatable-panel>
      </div>
    </div>

    <notifications group="listagem-usuarios" />
  </div>
</template>

<style lang="scss">
  #listar-usuarios {
    .details {
      width: 15px;
    }

    .search-bar {
      & .container-fluid {
        padding-left: 0;

        & button {
          margin-left: 15px;
        }
      }
    }
  }
</style>

<script>
  import Vue from 'vue';

  import DatatablePanel from 'metawesome-datatable';
  import CustomActions from './CustomActions';
  import SearchBar from './SearchBar';
  import Uteis from '@/mixins/utils.js';

  Vue.component('actions-gitlab', CustomActions);

  export default {
    components: {
      DatatablePanel,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        searchBar: SearchBar,
        fields: [
          { name: 'nome', sortField: 'nome', title: 'Nome' },
          { name: 'email', sortField: 'email', title: 'E-mail' },
          { name: 'horas_liberadas', sortField: 'horas_liberadas', title: 'Horas Liberadas', callback: this.getDuracao },
          { name: 'tipo_contratacao', sortField: 'tipo_contratacao', title: 'Forma de Contratação' },
          { name: '__component:actions-gitlab', title: 'Ações', titleClass: 'details', dataClass: 'details', },
        ],
      };
    },
  }
</script>
